import acorn_squash from "./data/acorn-squash.json";
import adjuma_pepper from "./data/adjuma-pepper.json";
import aji_dulce_pepper from "./data/aji-dulce-pepper.json";
import aleppo_pepper from "./data/aleppo-pepper.json";
import almond from "./data/almond.json";
import anaheim_pepper from "./data/anaheim-pepper.json";
import apple from "./data/apple.json";
import apricot from "./data/apricot.json";
import artichoke from "./data/artichoke.json";
import arugula from "./data/arugula.json";
import asian_pear from "./data/asian-pear.json";
import asparagus from "./data/asparagus.json";
import banana_pepper from "./data/banana-pepper.json";
import barley from "./data/barley.json";
import basil from "./data/basil.json";
import beet from "./data/beet.json";
import belgian_endive from "./data/belgian-endive.json";
import bibb_lettuce from "./data/bibb-lettuce.json";
import bing_cherry from "./data/bing-cherry.json";
import birds_eye_chili from "./data/birds-eye-chili.json";
import bishops_crown_pepper from "./data/bishops-crown-pepper.json";
import black_habanero from "./data/black-habanero.json";
import black_prince_tomato from "./data/black-prince-tomato.json";
import black_salsify from "./data/black-salsify.json";
import blackberry from "./data/blackberry.json";
import blue_lake_bean from "./data/blue-lake-bean.json";
import blue_oyster_mushroom from "./data/blue-oyster-mushroom.json";
import blueberry from "./data/blueberry.json";
import bok_choy from "./data/bok-choy.json";
import borage from "./data/borage.json";
import brazilian_starfish_pepper from "./data/brazilian-starfish-pepper.json";
import broccoli from "./data/broccoli.json";
import brussels_sprout from "./data/brussels-sprout.json";
import butternut_squash from "./data/butternut-squash.json";
import california_poppy from "./data/california-poppy.json";
import cannabis from "./data/cannabis.json";
import cantaloupe from "./data/cantaloupe.json";
import carrot from "./data/carrot.json";
import cascabel_chili from "./data/cascabel-chili.json";
import cauliflower from "./data/cauliflower.json";
import cayenne_pepper from "./data/cayenne-pepper.json";
import celeriac_root from "./data/celeriac-root.json";
import celery from "./data/celery.json";
import chamomile from "./data/chamomile.json";
import chantrelle_mushroom from "./data/chantrelle-mushroom.json";
import cheongyang_pepper from "./data/cheongyang-pepper.json";
import cherokee_purple_tomato from "./data/cherokee-purple-tomato.json";
import cherry_belle_radish from "./data/cherry-belle-radish.json";
import cherry_stuffer_pepper from "./data/cherry-stuffer-pepper.json";
import cherry_tomato from "./data/cherry-tomato.json";
import chile_de_aborol_pepper from "./data/chile-de-aborol-pepper.json";
import cilantro from "./data/cilantro.json";
import cinnamon_cap_mushroom from "./data/cinnamon-cap-mushroom.json";
import claytonia from "./data/claytonia.json";
import collard_greens from "./data/collard-greens.json";
import corn from "./data/corn.json";
import cotton from "./data/cotton.json";
import cremini_mushroom from "./data/cremini-mushroom.json";
import cubanelle_pepper from "./data/cubanelle-pepper.json";
import cucumber from "./data/cucumber.json";
import curly_endive from "./data/curly-endive.json";
import curly_kale from "./data/curly-kale.json";
import dandelion from "./data/dandelion.json";
import dark_opal_basil from "./data/dark-opal-basil.json";
import datil_pepper from "./data/datil-pepper.json";
import delicata_squash from "./data/delicata-squash.json";
import diablito_pepper from "./data/diablito-pepper.json";
import dill from "./data/dill.json";
import dundicut_pepper from "./data/dundicut-pepper.json";
import echinacea from "./data/echinacea.json";
import eggplant from "./data/eggplant.json";
import facing_heaven_pepper from "./data/facing-heaven-pepper.json";
import fatilii_pepper from "./data/fatilii-pepper.json";
import fava_bean from "./data/fava-bean.json";
import fennel from "./data/fennel.json";
import flower from "./data/flower.json";
import french_breakfast_radish from "./data/french-breakfast-radish.json";
import fresno_pepper from "./data/fresno-pepper.json";
import fuji_apple from "./data/fuji-apple.json";
import gala_apple from "./data/gala-apple.json";
import galangal from "./data/galangal.json";
import garlic_chives from "./data/garlic-chives.json";
import garlic from "./data/garlic.json";
import generic_plant from "./data/generic-plant.json";
import german_chamomile from "./data/german-chamomile.json";
import ghost_pepper from "./data/ghost-pepper.json";
import ginger from "./data/ginger.json";
import golden_beet from "./data/golden-beet.json";
import golden_delicious_apple from "./data/golden-delicious-apple.json";
import granny_smith_apple from "./data/granny-smith-apple.json";
import green_anjou_pear from "./data/green-anjou-pear.json";
import green_bartlett_pear from "./data/green-bartlett-pear.json";
import green_bell_pepper from "./data/green-bell-pepper.json";
import green_birds_eye_chili from "./data/green-birds-eye-chili.json";
import green_cabbage from "./data/green-cabbage.json";
import green_onion from "./data/green-onion.json";
import green_serrano_pepper from "./data/green-serrano-pepper.json";
import green_tabasco_pepper from "./data/green-tabasco-pepper.json";
import green_zebra_tomato from "./data/green-zebra-tomato.json";
import guajillo_pepper from "./data/guajillo-pepper.json";
import habanero_pepper from "./data/habanero-pepper.json";
import hemp from "./data/hemp.json";
import hillbilly_tomato from "./data/hillbilly-tomato.json";
import honeydew_melon from "./data/honeydew-melon.json";
import hop from "./data/hop.json";
import hungarian_wax_pepper from "./data/hungarian-wax-pepper.json";
import iceberg_lettuce from "./data/iceberg-lettuce.json";
import icicle_radish from "./data/icicle-radish.json";
import indigo from "./data/indigo.json";
import jalapeno from "./data/jalapeno.json";
import japanese_yam from "./data/japanese-yam.json";
import kabocha_squash from "./data/kabocha-squash.json";
import kohlrabi from "./data/kohlrabi.json";
import lacinato_kale from "./data/lacinato-kale.json";
import lavender from "./data/lavender.json";
import leek from "./data/leek.json";
import lemon_balm from "./data/lemon-balm.json";
import lemon_drop_pepper from "./data/lemon-drop-pepper.json";
import lemon_verbena from "./data/lemon-verbena.json";
import lemongrass from "./data/lemongrass.json";
import lima_bean from "./data/lima-bean.json";
import lions_mane_mushroom from "./data/lions-mane-mushroom.json";
import looseleaf_lettuce from "./data/looseleaf-lettuce.json";
import lovage from "./data/lovage.json";
import madame_jeanette_pepper from "./data/madame-jeanette-pepper.json";
import malagueta_pepper from "./data/malagueta-pepper.json";
import marjoram from "./data/marjoram.json";
import marshmallow from "./data/marshmallow.json";
import medusa_pepper from "./data/medusa-pepper.json";
import melon from "./data/melon.json";
import millet from "./data/millet.json";
import mint from "./data/mint.json";
import money_tree from "./data/money-tree.json";
import mugwort from "./data/mugwort.json";
import mushroom from "./data/mushroom.json";
import napa_cabbage from "./data/napa-cabbage.json";
import nectarine from "./data/nectarine.json";
import oat from "./data/oat.json";
import okra from "./data/okra.json";
import onion_chive from "./data/onion-chive.json";
import orange_bell_pepper from "./data/orange-bell-pepper.json";
import orange_scotch_bonnet from "./data/orange-scotch-bonnet.json";
import oregano from "./data/oregano.json";
import ornamental_gourd from "./data/ornamental-gourd.json";
import parsley from "./data/parsley.json";
import parsnip from "./data/parsnip.json";
import pattypan_squash from "./data/pattypan-squash.json";
import peach from "./data/peach.json";
import peanut from "./data/peanut.json";
import peppadew_pepper from "./data/peppadew-pepper.json";
import pequin_pepper from "./data/pequin-pepper.json";
import peter_pepper from "./data/peter-pepper.json";
import pimento_pepper from "./data/pimento-pepper.json";
import pineapple_tomato from "./data/pineapple-tomato.json";
import pink_oyster_mushroom from "./data/pink-oyster-mushroom.json";
import plantain from "./data/plantain.json";
import plum from "./data/plum.json";
import poblano_pepper from "./data/poblano-pepper.json";
import pointed_cabbage from "./data/pointed-cabbage.json";
import porcini_mushroom from "./data/porcini-mushroom.json";
import portabello_mushroom from "./data/portabello-mushroom.json";
import psilocybin_mushroom from "./data/psilocybin-mushroom.json";
import pumpkin from "./data/pumpkin.json";
import purple_carrot from "./data/purple-carrot.json";
import purple_cauliflower from "./data/purple-cauliflower.json";
import purple_pod_bean from "./data/purple-pod-bean.json";
import purple_potato from "./data/purple-potato.json";
import radicchio from "./data/radicchio.json";
import rainbow_chard from "./data/rainbow-chard.json";
import rainier_cherry from "./data/rainier-cherry.json";
import raspberry from "./data/raspberry.json";
import red_anjou_pear from "./data/red-anjou-pear.json";
import red_bartlett_pear from "./data/red-bartlett-pear.json";
import red_bell_pepper from "./data/red-bell-pepper.json";
import red_cabbage from "./data/red-cabbage.json";
import red_carrot from "./data/red-carrot.json";
import red_chard from "./data/red-chard.json";
import red_curly_kale from "./data/red-curly-kale.json";
import red_giant_mustard from "./data/red-giant-mustard.json";
import red_gold_potato from "./data/red-gold-potato.json";
import red_kuri_squash from "./data/red-kuri-squash.json";
import red_onion from "./data/red-onion.json";
import red_pointed_cabbage from "./data/red-pointed-cabbage.json";
import red_russian_kale from "./data/red-russian-kale.json";
import red_savina_pepper from "./data/red-savina-pepper.json";
import red_scotch_bonnet from "./data/red-scotch-bonnet.json";
import red_serrano_pepper from "./data/red-serrano-pepper.json";
import red_tabasco_pepper from "./data/red-tabasco-pepper.json";
import rice from "./data/rice.json";
import rocoto_pepper from "./data/rocoto-pepper.json";
import romaine_lettuce from "./data/romaine-lettuce.json";
import rosemary from "./data/rosemary.json";
import runner_bean from "./data/runner-bean.json";
import russet_potato from "./data/russet-potato.json";
import rutabaga from "./data/rutabaga.json";
import rye from "./data/rye.json";
import sage from "./data/sage.json";
import salsify from "./data/salsify.json";
import santa_fe_grande_pepper from "./data/santa-fe-grande-pepper.json";
import savoy_cabbage from "./data/savoy-cabbage.json";
import shallot from "./data/shallot.json";
import shiitake_mushroom from "./data/shiitake-mushroom.json";
import shishito_pepper from "./data/shishito-pepper.json";
import siling_labuyo_pepper from "./data/siling-labuyo-pepper.json";
import snap_pea from "./data/snap-pea.json";
import soybean from "./data/soybean.json";
import spaghetti_squash from "./data/spaghetti-squash.json";
import spinach from "./data/spinach.json";
import spring_onion from "./data/spring-onion.json";
import st_johns_wort from "./data/st-johns-wort.json";
import stevia from "./data/stevia.json";
import strawberry from "./data/strawberry.json";
import striped_cavern_tomato from "./data/striped-cavern-tomato.json";
import sugarcane from "./data/sugarcane.json";
import sunflower from "./data/sunflower.json";
import sunray_tomato from "./data/sunray-tomato.json";
import sweet_italian_pepper from "./data/sweet-italian-pepper.json";
import sweet_potato from "./data/sweet-potato.json";
import swiss_chard from "./data/swiss-chard.json";
import taro from "./data/taro.json";
import thyme from "./data/thyme.json";
import tomatillo from "./data/tomatillo.json";
import tomato from "./data/tomato.json";
import trinidad_moruga_scorpion_pepper from "./data/trinidad-moruga-scorpion-pepper.json";
import trinidad_scorpion_butch_t_pepper from "./data/trinidad-scorpion-butch-t-pepper.json";
import trumpet_mushroom from "./data/trumpet-mushroom.json";
import tulsi from "./data/tulsi.json";
import turmeric from "./data/turmeric.json";
import turnip from "./data/turnip.json";
import watercress from "./data/watercress.json";
import watermelon_radish from "./data/watermelon-radish.json";
import watermelon from "./data/watermelon.json";
import wax_bean from "./data/wax-bean.json";
import wheat from "./data/wheat.json";
import white_button_mushroom from "./data/white-button-mushroom.json";
import white_carrot from "./data/white-carrot.json";
import white_onion from "./data/white-onion.json";
import white_oyster_mushroom from "./data/white-oyster-mushroom.json";
import wormwood from "./data/wormwood.json";
import yellow_bell_pepper from "./data/yellow-bell-pepper.json";
import yellow_carrot from "./data/yellow-carrot.json";
import yellow_cauliflower from "./data/yellow-cauliflower.json";
import yellow_onion from "./data/yellow-onion.json";
import yellow_oyster_mushroom from "./data/yellow-oyster-mushroom.json";
import yellow_scotch_bonnet from "./data/yellow-scotch-bonnet.json";
import yellow_squash from "./data/yellow-squash.json";
import yukon_gold_potato from "./data/yukon-gold-potato.json";
import zucchini from "./data/zucchini.json";

import { Crops } from "./interfaces";
import { kebabCase } from "lodash";
import aliases from "./aliases.json";

const SNAKE_CASE_CROPS: Crops = {
  acorn_squash,
  adjuma_pepper,
  aji_dulce_pepper,
  aleppo_pepper,
  almond,
  anaheim_pepper,
  apple,
  apricot,
  artichoke,
  arugula,
  asian_pear,
  asparagus,
  banana_pepper,
  barley,
  basil,
  beet,
  belgian_endive,
  bibb_lettuce,
  bing_cherry,
  birds_eye_chili,
  bishops_crown_pepper,
  black_habanero,
  black_prince_tomato,
  black_salsify,
  blackberry,
  blue_lake_bean,
  blue_oyster_mushroom,
  blueberry,
  bok_choy,
  borage,
  brazilian_starfish_pepper,
  broccoli,
  brussels_sprout,
  butternut_squash,
  california_poppy,
  cannabis,
  cantaloupe,
  carrot,
  cascabel_chili,
  cauliflower,
  cayenne_pepper,
  celeriac_root,
  celery,
  chamomile,
  chantrelle_mushroom,
  cheongyang_pepper,
  cherokee_purple_tomato,
  cherry_belle_radish,
  cherry_stuffer_pepper,
  cherry_tomato,
  chile_de_aborol_pepper,
  cilantro,
  cinnamon_cap_mushroom,
  claytonia,
  collard_greens,
  corn,
  cotton,
  cremini_mushroom,
  cubanelle_pepper,
  cucumber,
  curly_endive,
  curly_kale,
  dandelion,
  dark_opal_basil,
  datil_pepper,
  delicata_squash,
  diablito_pepper,
  dill,
  dundicut_pepper,
  echinacea,
  eggplant,
  facing_heaven_pepper,
  fatilii_pepper,
  fava_bean,
  fennel,
  flower,
  french_breakfast_radish,
  fresno_pepper,
  fuji_apple,
  gala_apple,
  galangal,
  garlic_chives,
  garlic,
  generic_plant,
  german_chamomile,
  ghost_pepper,
  ginger,
  golden_beet,
  golden_delicious_apple,
  granny_smith_apple,
  green_anjou_pear,
  green_bartlett_pear,
  green_bell_pepper,
  green_birds_eye_chili,
  green_cabbage,
  green_onion,
  green_serrano_pepper,
  green_tabasco_pepper,
  green_zebra_tomato,
  guajillo_pepper,
  habanero_pepper,
  hemp,
  hillbilly_tomato,
  honeydew_melon,
  hop,
  hungarian_wax_pepper,
  iceberg_lettuce,
  icicle_radish,
  indigo,
  jalapeno,
  japanese_yam,
  kabocha_squash,
  kohlrabi,
  lacinato_kale,
  lavender,
  leek,
  lemon_balm,
  lemon_drop_pepper,
  lemon_verbena,
  lemongrass,
  lima_bean,
  lions_mane_mushroom,
  looseleaf_lettuce,
  lovage,
  madame_jeanette_pepper,
  malagueta_pepper,
  marjoram,
  marshmallow,
  medusa_pepper,
  melon,
  millet,
  mint,
  money_tree,
  mugwort,
  mushroom,
  napa_cabbage,
  nectarine,
  oat,
  okra,
  onion_chive,
  orange_bell_pepper,
  orange_scotch_bonnet,
  oregano,
  ornamental_gourd,
  parsley,
  parsnip,
  pattypan_squash,
  peach,
  peanut,
  peppadew_pepper,
  pequin_pepper,
  peter_pepper,
  pimento_pepper,
  pineapple_tomato,
  pink_oyster_mushroom,
  plantain,
  plum,
  poblano_pepper,
  pointed_cabbage,
  porcini_mushroom,
  portabello_mushroom,
  psilocybin_mushroom,
  pumpkin,
  purple_carrot,
  purple_cauliflower,
  purple_pod_bean,
  purple_potato,
  radicchio,
  rainbow_chard,
  rainier_cherry,
  raspberry,
  red_anjou_pear,
  red_bartlett_pear,
  red_bell_pepper,
  red_cabbage,
  red_carrot,
  red_chard,
  red_curly_kale,
  red_giant_mustard,
  red_gold_potato,
  red_kuri_squash,
  red_onion,
  red_pointed_cabbage,
  red_russian_kale,
  red_savina_pepper,
  red_scotch_bonnet,
  red_serrano_pepper,
  red_tabasco_pepper,
  rice,
  rocoto_pepper,
  romaine_lettuce,
  rosemary,
  runner_bean,
  russet_potato,
  rutabaga,
  rye,
  sage,
  salsify,
  santa_fe_grande_pepper,
  savoy_cabbage,
  shallot,
  shiitake_mushroom,
  shishito_pepper,
  siling_labuyo_pepper,
  snap_pea,
  soybean,
  spaghetti_squash,
  spinach,
  spring_onion,
  st_johns_wort,
  stevia,
  strawberry,
  striped_cavern_tomato,
  sugarcane,
  sunflower,
  sunray_tomato,
  sweet_italian_pepper,
  sweet_potato,
  swiss_chard,
  taro,
  thyme,
  tomatillo,
  tomato,
  trinidad_moruga_scorpion_pepper,
  trinidad_scorpion_butch_t_pepper,
  trumpet_mushroom,
  tulsi,
  turmeric,
  turnip,
  watercress,
  watermelon_radish,
  watermelon,
  wax_bean,
  wheat,
  white_button_mushroom,
  white_carrot,
  white_onion,
  white_oyster_mushroom,
  wormwood,
  yellow_bell_pepper,
  yellow_carrot,
  yellow_cauliflower,
  yellow_onion,
  yellow_oyster_mushroom,
  yellow_scotch_bonnet,
  yellow_squash,
  yukon_gold_potato,
  zucchini,
};

export const CROPS: Crops = Object.entries(SNAKE_CASE_CROPS)
  .reduce((crops, [slug, crop]) => {
    crops[kebabCase(slug)] = crop;
    return crops;
  }, {} as Crops);
export const SLUGS: string[] = Object.keys(CROPS).map(slug => kebabCase(slug));
export const ICON_URLS: string[] = Object.values(CROPS).map(crop => crop.icon);

export const ALIASED_SLUG_LOOKUP: Record<string, string> = Object.entries(aliases)
  .reduce((
    slug_lookup: Record<string, string>,
    [slug, slug_aliases]: [string, string[]],
  ) => {
    slug_aliases.map(slug_alias => {
      slug_lookup[slug_alias] = slug;
    });
    return slug_lookup;
  }, {} as Record<string, string>);
